import { action, makeObservable, observable } from 'mobx'
import { between } from 'utils/validation-utils'
import { validationContext, required } from 'validx'
import {
  IInventoryItemPricingEditor,
  InventoryItemMarkdownValues,
  InventoryItemPricingValues,
} from './inventory-item-pricing-editor'
import { InventoryItemPricing } from 'admin/inventory/InventoryItem'

/**
 * View Model for Inventory Items of type Markdown.
 */
export class MarkdownEditorViewModel implements IInventoryItemPricingEditor {
  /**
   * The rate by which the job's price will be marked down.
   */
  clientMarkdownRate = 0

  /**
   * The rate by which the pro's payout will be marked down.
   */
  proPayoutMarkdownRate = 0

  /**
   * Validation context.
   */
  validation = validationContext(this, {
    clientMarkdownRate: [
      required('A client markdown rate is required.'),
      between(0, 100, 'The rate must be between 0 and 100.'),
    ],

    proPayoutMarkdownRate: [
      required('A pro payout markdown rate is required.'),
      between(0, 100, 'The rate must be between 0 and 100.'),
    ],
  })

  constructor() {
    makeObservable(this, {
      clientMarkdownRate: observable,
      proPayoutMarkdownRate: observable,
      hydrate: action.bound,
      reset: action.bound,
    })
  }

  /**
   * @inheritdoc
   */
  validate(): boolean {
    return this.validation.reset().validate().isValid
  }

  /**
   * @inheritdoc
   */
  hydrate(values: InventoryItemMarkdownValues): void {
    this.clientMarkdownRate = values.clientMarkdownRate
    this.proPayoutMarkdownRate = values.proPayoutMarkdownRate
  }

  /**
   * @inheritdoc
   */
  toValues(): InventoryItemPricingValues {
    return {
      type: InventoryItemPricing.Markdown,
      clientMarkdownRate: this.clientMarkdownRate,
      proPayoutMarkdownRate: this.proPayoutMarkdownRate,
    }
  }

  /**
   * @inheritdoc
   */
  reset() {
    this.clientMarkdownRate = 0
    this.proPayoutMarkdownRate = 0
    this.validation.reset()
  }
}
